export class CurrencyDto {

  public static readonly NONE: CurrencyDto = new CurrencyDto({code: 'NONE', symbol: '', html: ''});

  public code!: string;
  public symbol!: string;
  public html!: string;

  constructor(init?: Partial<CurrencyDto> | undefined) {
    Object.assign(this, init);
  }
}
